import React from 'react'
import injectSheet from 'react-jss'
import styles from './form-row.styles'
import classNames from 'classnames'

const FormRow = ({ classes, className, ...props }) => {
  return <div className={classNames(classes.row, className)} {...props} />
}

export default injectSheet(styles)(FormRow)
